import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useState } from 'react';
import Dialog from '@/components/Dialog';
import MenuItemLoadingIndicator from '@/components/Menu/MenuItemLoadingIndicator';
import useDeleteThumbnail from './useDeleteThumbnail';
import { FormattedMessage } from 'react-intl';

type DeleteThumbnailProps = Omit<
  MenuItemProps,
  'onClick' | 'disabled' | 'children'
>;

const DeleteThumbnail = (props: DeleteThumbnailProps) => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteThumbnail = useDeleteThumbnail();

  const handleDeleteThumbnail = async (): Promise<void> => {
    setDeleting(true);
    setConfirmationDialogOpen(false);

    await deleteThumbnail();

    setDeleting(false);
  };

  return (
    <>
      <MenuItem
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
        {...props}
      >
        <ListItemIcon>
          {deleting ? (
            <MenuItemLoadingIndicator />
          ) : (
            <DeleteIcon color="error" />
          )}
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="portfolio.challenge.thumbnail_header.controls.delete.label" />
        </ListItemText>
      </MenuItem>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.challenge.thumbnail_header.controls.delete.confirmation_dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.challenge.thumbnail_header.controls.delete.confirmation_dialog.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={handleDeleteThumbnail} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteThumbnail;
